import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { FormControl } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { map, take } from "rxjs/operators";
import { BusinessService } from "../../../services/business.service";
import { NuveiService, SavedNuveiApplicationForm } from "../../../services/nuvei.service";
import { timer } from "rxjs";
import moment from "moment/moment";

@Component({
  selector: 'app-nuvei-application-preview',
  templateUrl: './nuvei-application-preview.component.html',
  styleUrls: ['./nuvei-application-preview.component.scss']
})
export class NuveiApplicationPreviewComponent implements OnInit {

  @Input() signatures!: SavedNuveiApplicationForm['signatures'];
  @Input() formDocument!: SavedNuveiApplicationForm['formDocument'];
  @Input() applicationStatus!: SavedNuveiApplicationForm['status'];
  @Input() requiresGuarantorSignature!: boolean;
  @Input() submitting = false;

  @Output() onSignatureRevoke = new EventEmitter<string>();
  @Output() submitApplication = new EventEmitter<string>();

  submitCheckboxControl = new FormControl<boolean>(false);
  waitingForDocumentApproval = false;

  downloadAvailable = true;
  downloadTimer$ = timer(0, 1000).pipe(
      map(_ => {
        if(!this.formDocument!.documentExpiration)
          return null;
        if(moment(this.formDocument!.documentExpiration).isBefore()) {
          this.zone.run(() => {
            this.downloadAvailable = false
          });
        }
        return moment(moment(this.formDocument!.documentExpiration).diff(moment())).format('mm:ss');
      })
  );

  safeDocumentUrl!: SafeUrl;
  extendDocument = false;

  get isFinalDocument() {
    return this.requiresGuarantorSignature && this.signatures.guarantor?.submitted
      || !this.requiresGuarantorSignature && this.signatures.owner?.submitted;
  }

  constructor(
      private domSanitizer: DomSanitizer,
      private businessService: BusinessService,
      private zone: NgZone,
      private nuveiService: NuveiService,
  ) {}

  async ngOnInit() {
    let link = this.formDocument!.documentUrl;
    if(!this.isFinalDocument)
      link += '#toolbar=0';
    this.safeDocumentUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(link);
    // if(this.requiresGuarantorSignature && !this.signatures.guarantor?.submitted)
    //   this.extendDocument = true;
    if(this.formDocument?.documentApproval)
      this.submitCheckboxControl.setValue(true, { emitEvent: false });

    const business = await this.businessService.selectedBusiness$.pipe(take(1)).toPromise();
    this.nuveiService.addEvent(business!.businessId, 'View');
  }

  async signatureApprovalClick(event: MatCheckboxChange) {
    const business = (await this.businessService.selectedBusiness$.pipe(take(1)).toPromise())!;
    try {
      if(event.checked) {
        this.waitingForDocumentApproval = true;
        this.formDocument!.documentApproval = await this.nuveiService.requestApproval(business.businessId, 'document');
        this.waitingForDocumentApproval = false;
      } else {
        this.formDocument!.documentApproval = undefined;
        await this.nuveiService.revokeApproval(business.businessId, this.formDocument!.documentApproval!, 'document');
      }
    } catch (e) {
      this.submitCheckboxControl.setValue(false);
      this.formDocument!.documentApproval = undefined;
      this.waitingForDocumentApproval = false;
    }
  }

  async submit() {
    this.submitting = true;
    this.submitApplication.emit();
    this.submitting = false;
  }

}
